import React, { useState } from 'react';
import axios from 'axios';
import './ChangePassword.css';

const ChangePass = ({onClose}) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    try {
      const payload = {
        currentPassword,
        newPassword,
      };
      const response = await axios.post(
        "https://api.example.com/change-password", // Replace with your API endpoint
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      setSuccessMessage(response.data.message || "Password changed successfully!");
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Failed to change password. Try again.");
    } finally {
      setLoading(false);
    }
  };

  
  const closePopup = () => {
    onClose(false);
};
  return (
    <div className='.main-container'>
      <div className="popup-overlay">
        <div className="popup-container">
          <button className="close-btn" onClick={closePopup}>
            &times;
          </button>
          <h2>Change Password</h2>
          <form onSubmit={handleChangePassword} className="change-password-form">
            <div className="form-group">
              <label>Enter Old Password</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Enter New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            {loading && <p>Loading...</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            {successMessage && <p className="success-message">{successMessage}</p>}
            <button type="submit" className="submit-btn">
              Change Password
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ChangePass